import {
  colors,
  createGrid,
  LOADING_SPINNER_CLASS,
  maxBreakpoints,
  minBreakpoints,
} from '@noths/polaris-client-ribbons-design-system';
import { fontSize, mediaQuery, pxToRem, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing, text, designSystemFontSizes } = theme;

export const heading = css`
  ${fontSize(designSystemFontSizes.BODY.MD)}
  margin: 0 auto;
  text-align: center;
`;

export const checkmarkIcon = css`
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
  margin: 0 auto;
  display: block;
`;

export const visitShopLink = css`
  margin-right: ${pxToRem(spacing.lg)};

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      margin: 0 auto ${pxToRem(spacing.md)};
      ${fontSize(designSystemFontSizes.BODY.SM)};
    `,
  )}
`;

export const successFooterButtons = css`
  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: flex;
      flex-direction: column;
      margin-bottom: ${stack(spacing.md)}px;
    `,
  )}
`;

export const successBodyWrapper = css`
  padding: ${pxToRem(spacing.xl)} ${pxToRem(spacing.md)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: ${pxToRem(spacing.xl)};
    `,
  )}
`;

export const partnerName = css`
  ${fontSize(designSystemFontSizes.HEADING.XS)}
  display: block;
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
`;

export const productInfo = css`
  display: flex;
  border-bottom: solid 1px ${colors.neutralLight};
  align-items: center;
`;

export const productInfoImage = css`
  border-radius: ${pxToRem(10)};
  margin: ${pxToRem(spacing.xl)};
`;

export const productInfoTitle = css`
  font-size: ${text.xxs.SMALL.fontSize}px;
`;

export const textField = css`
  margin: ${stack(spacing.xl)};
`;

export const form = css`
  height: 100%;
`;

export const fields = css`
  padding: ${pxToRem(spacing.xl)} ${pxToRem(spacing.md)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: ${pxToRem(spacing.xl)};
    `,
  )}
`;

export const nameAndEmailWrapper = css`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      ${createGrid(2)}
    `,
  )}
`;

export const checkbox = css`
  margin-bottom: 0;
`;

export const submitButton = css`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: inline-block;
      width: ${pxToRem(159)};
    `,
  )}
`;

export const loadingSpinner = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .${LOADING_SPINNER_CLASS} {
    width: ${pxToRem(spacing.xxxl)};
    height: ${pxToRem(spacing.xxxl)};
  }
`;
